<template>
    <div class="wrap">
        <div v-if="showLoader" style="background: rgba(0,0,0,0.5);position: fixed;display: flex;justify-content:center;align-items:center;z-index: 1000001;left: 0;top: 0;height: 100%;width: 100%;">
            <img src="static/img/loader.gif" style="max-width:100px;"/>
        </div>
        <div class="library-wrap">
            <div class="line-item toolbar">
                <div class="left-item">
                    <div class="search open-search">
                        <md-icon class="search-glass-icon">search</md-icon>
                        <div class="search-field">
                            <div class="md-input-focused md-input-container">
                                <input type="text" class="md-input" v-model="filterString"></input>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right-item tour-buttons">
                    <span>
                        <div class="el"></div>
                        <div class="el"></div>
                        <div class="el"></div>
                    </span>
                </div>
            </div>
            <!-- stories -->
            <div class="library-item">
                <div class="line-item hovered-line">
                    <div class="left-item">
                        <div class="el">
                            <h3>Stories </h3>
                        </div>
                        <div class="el" v-if="categoryHasErrors(library.story)">
                            <md-icon title="Stories has errors" class="orange-color">error_outline</md-icon>
                        </div>
                    </div>
                    <div class="right-item">
                        <div>
                            <div class="el">
                                <md-button title="Upload Stories" class="md-icon-button ">
                                    <form id="storyForm" enctype="multipart/form-data" novalidate>
                                        <input type="hidden" name="category" value="story"/>
                                        <input class=" file-input" type="file" name="files" multiple="multiple" @change="onFileUploadMulti($event, 'story')"/>
                                    </form>
                                    <md-icon>file_upload</md-icon>
                                </md-button>
                            </div>
                            <div class="el" v-if="storiesExpand">
                                <md-button class="md-icon-button" @click="toggleExpandAll('story')">
                                    <md-icon v-bind:title="[expandAll['story'] ? 'close all' : 'open all']">{{ expandAll['story'] ? 'first_page' : 'last_page' }}</md-icon>
                                </md-button>
                            </div>
                            <div class="el">
                                <md-button title="Open Stories" class="md-icon-button" @click="toggleExpand('story')">
                                    <md-icon v-bind:class="[storiesExpand ? 'icon-expand_more' : 'icon-expand_less']"></md-icon>
                                </md-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- stories children -->
            <div class="inner-library-section slideDown" v-if="storiesExpand">
                <md-checkbox v-model="selectAllCheckBox" @change="selectAllCheckEvent($event)" :value="1">SELECT All</md-checkbox>
                <div class="wrap-inner-line list-group-item" v-for="(item, index) in library.story" v-if="filterCheck(index)">
                    <div class="inner-line">
                        <div class="line-item hovered-line no-outline-btn">
                            <div class="left-item">
                                <div class="el">
                                    <h4>{{ index }}</h4>
                                </div>
                                <div class="el" v-if="hasVideo(item,'category')">
                                    <md-icon>videocam</md-icon>
                                </div>
                                <div class="el" v-if="friendlyNameHasErrors(item)">
                                    <md-icon title="This item has errors" class="orange-color">error_outline</md-icon>
                                </div>
                            </div>
                            <div class="right-item">
                                <div class="el time-el">
                                    <em></em>
                                </div>
                                <div>
                                    <div class="el" v-if="false">
                                        <md-button title="Delete" class="md-icon-button delete-btn top-index" :disabled="true">
                                            <md-icon class="icon-delete"></md-icon>
                                        </md-button>
                                    </div>
                                    <div class="el" v-if="false">
                                        <md-button aria-label="Settings menu" class="md-icon-button " :disabled="true">
                                            <form>
                                                <input class="file-input" type="file"/>
                                            </form>
                                            <md-icon>file_upload</md-icon>
                                        </md-button>
                                    </div>
                                    <div class="el">
                                        <md-button aria-label="Open section" class="md-icon-button" @click="toggleLanguageExpand('story', index)">
                                            <md-icon v-bind:class="[item.expanded ? 'icon-expand_more' : 'icon-expand_less']"></md-icon>
                                        </md-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- stories children languages -->
                    <div class="hidden-el" v-bind:class="[item.expanded ? 'open' : '']">
                        <div class="inner-line line-item hovered-line" v-for="el in item.media" :key="el.id">
                            <div class="el">
                                <!-- {{arraListName}}        -->
                                <md-checkbox v-model="arrayLibraryDetails" @change="checkBoxGetName($event,el.filename)" :attName="el.filename" :value="el.id"></md-checkbox>
                            </div>
                            <div class="left-item">
                                <div class="el indent">
                                    <h4 class="grey-color">
                                        <md-icon v-if="el.uploaded === true" title="File exists" class="green-color">done</md-icon>
                                        <md-icon v-else-if="el.uploaded === false" title="File is not in your library" class="red-color">cancel</md-icon>
                                        <i>{{ el.filename }}</i>
                                    </h4>
                                </div>
                                <div class="el" v-if="hasVideo(el,'file')">
                                    <md-icon>videocam</md-icon>
                                </div>
                                <div class="el" v-else>
                                    <md-icon></md-icon>
                                </div>
                                {{ el.file_length }}
                            </div>
                            <div v-if="el.file_length">
                                <div class="el" v-if="el.isVideo">
                                    <div class="el logout-button">
                                        <img @click="playMedia(el, 1)" class="imgAudioVideo" src="static/img/videoPlay.png"/>
                                    </div>
                                </div>
                                <div class="el" v-else>
                                    <div class="el logout-button">
                                        <img @click="playMedia(el, 2)" class="imgAudioVideo" src="static/img/videoPlay.png"/>
                                    </div>
                                </div>
                            </div>
                            <div class="right-item">
                                <div>
                                    <div class="el">
                                        <!-- <md-button title="Delete" class="md-icon-button delete-btn" @click="confirmRemove(el)">
                                          <md-icon class="icon-delete"></md-icon>
                                        </md-button> -->
                                    </div>
                                    <div class="el">
                                        <md-button aria-label="Settings menu" class="md-icon-button" v-if="false" :disabled="true">
                                            <form>
                                                <input class="file-input" type="file"/>
                                            </form>
                                            <md-icon>file_upload</md-icon>
                                        </md-button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
                <div v-if="shoMultiple" style="float:right">
                    <button class="ManualBtn ManualBtncancelMultiple" style="background-color: #00a8ca !important;" type="submit" @click="multipleDownload('STORY')">DOWNLOAD</button>
                    <button class="ManualBtn ManualBtncancelMultiple" style=" background-color: #d9534f !important" @click="confirmRemoveMultipl(1)">DELETE</button>
                </div>
            </div>
            <!-- fillers -->
            <div class="library-item">
                <div class="line-item hovered-line">
                    <div class="left-item">
                        <div class="el">
                            <h3>Fillers</h3>
                        </div>
                        <div class="el" v-if="categoryHasErrors(library.filler)">
                            <md-icon title="Fillers has errors" class="orange-color">error_outline</md-icon>
                        </div>
                    </div>
                    <div class="right-item">
                        <div>
                            <div class="el">
                                <md-button title="Upload Fillers" class="md-icon-button">
                                    <form id="fillerForm" enctype="multipart/form-data" novalidate>
                                        <input type="hidden" name="category" value="story"/>
                                        <input class="file-input" name="files" type="file" multiple="multiple" @change="onFileUploadMulti($event, 'filler')"/>
                                    </form>
                                    <md-icon>file_upload</md-icon>
                                </md-button>
                            </div>
                            <div class="el" v-if="fillersExpand">
                                <md-button class="md-icon-button" @click="toggleExpandAll('filler')">
                                    <md-icon v-bind:title="[expandAll['filler'] ? 'close all' : 'open all']">{{ expandAll['filler'] ? 'first_page' : 'last_page' }}</md-icon>
                                </md-button>
                            </div>
                            <div class="el">
                                <md-button title="Open Fillers" class="md-icon-button" @click="toggleExpand('filler')">
                                    <md-icon v-bind:class="[fillersExpand ? 'icon-expand_more' : 'icon-expand_less']"></md-icon>
                                </md-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- fillers children -->
            <div class="inner-library-section slideDown" v-if="fillersExpand">
                <md-checkbox v-model="selectAllCheckBoxFiller" @change="selectAllCheckEventFiller($event)" :value="1">SELECT All</md-checkbox>
                <draggable
                    :list="convertObjToFiller"
                    :disabled="!enabled"
                    class="list-group"
                    ghost-class="ghost"
                    :move="checkMove"
                    @update="onUpdate('Filler')"
                    @start="dragging = true"
                    @end="endDragging(false)"
                    title="Update sequence of story file"
                >
                    <div class="wrap-inner-line" v-for="(item, index) in library.filler" v-if="filterCheck(index)">
                        <div class="inner-line" title="Update sequence for filler files">
                            <div class="line-item hovered-line no-outline-btn">
                                <div class="left-item">
                                    <div class="el">
                                        <h4>{{ index }}</h4>
                                    </div>
                                    <div class="el" v-if="hasVideo(item,'category')">
                                        <md-icon>videocam</md-icon>
                                    </div>
                                    <div class="el" v-if="friendlyNameHasErrors(item)">
                                        <md-icon title="This item has errors" class="orange-color">error_outline</md-icon>
                                    </div>
                                </div>
                                <div class="right-item">
                                    <div class="el time-el">
                                        <em></em>
                                    </div>
                                    <div>
                                        <div class="el" v-if="false">
                                            <md-button title="Delete" class="md-icon-button delete-btn top-index" :disabled="true">
                                                <md-icon class="icon-delete"></md-icon>
                                            </md-button>
                                        </div>
                                        <div class="el" v-if="false">
                                            <md-button aria-label="Settings menu" class="md-icon-button" :disabled="true">
                                                <form>
                                                    <input class="file-input" type="file"/>
                                                </form>
                                                <md-icon>file_upload</md-icon>
                                            </md-button>
                                        </div>
                                        <div class="el">
                                            <md-button aria-label="Open section" class="md-icon-button" @click="toggleLanguageExpand('filler', index)">
                                                <md-icon v-bind:class="[item.expanded ? 'icon-expand_more' : 'icon-expand_less']"></md-icon>
                                            </md-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- filler children languages -->
                        <div class="hidden-el" v-bind:class="[item.expanded ? 'open' : '']">
                            <div class="inner-line line-item hovered-line" v-for="el in item.media" :key="el.id">
                                <div class="el">
                                    <!-- {{arraListName}}        -->
                                    <md-checkbox v-model="arrayLibraryDetailsFiller" @change="checkBoxGetName($event,el.filename)" :attName="el.filename" :value="el.id"></md-checkbox>
                                </div>
                                <div class="left-item">
                                    <div class="el indent">
                                        <h4 class="grey-color">
                                            <md-icon v-if="el.uploaded === true" title="File exists" class="green-color">done</md-icon>
                                            <md-icon v-else-if="el.uploaded === false" title="File is not in your library" class="red-color">cancel</md-icon>
                                            <i>{{ el.filename }}</i>
                                        </h4>
                                    </div>
                                    <div class="el" v-if="hasVideo(el,'file')">
                                        <md-icon>videocam</md-icon>
                                    </div>
                                    <div class="el" v-else>
                                        <md-icon></md-icon>
                                    </div>
                                    {{ el.file_length }}
                                </div>
                                <div v-if="el.file_length">
                                    <div class="el" v-if="el.isVideo">
                                        <img @click="playMedia(el, 1)" class="imgAudioVideo" src="static/img/videoPlay.png"/>
                                    </div>
                                    <div class="el" v-else>
                                        <img @click="playMedia(el, 2)" class="imgAudioVideo" src="static/img/videoPlay.png"/>
                                    </div>
                                </div>
                                <div class="right-item">
                                    <div>
                                        <div class="el">
                                            <!-- <div  class="el logout-button">
                                              <button data-v-0c732d5c=""  @click="addFileWithRoute(el.id)" type="button" class="md-button md-theme-default">
                                                <div class="md-ripple">
                                                  <span class="md-button-content cssForAddLibrray">Add Library File To A Tour</span>
                                                </div>
                                              </button>
                                            </div> -->
                                            <!-- <md-button title="Delete" class="md-icon-button delete-btn" @click="confirmRemove(el)">
                                              <md-icon class="icon-delete"></md-icon>
                                            </md-button> -->
                                        </div>
                                        <div class="el">
                                            <md-button aria-label="Settings menu" class="md-icon-button" v-if="false" :disabled="true">
                                                <form>
                                                    <input class="file-input" type="file"/>
                                                </form>
                                                <md-icon>file_upload</md-icon>
                                            </md-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </draggable>
                <div v-if="shoMultiplefiller" style="float:right">
                    <button class="ManualBtn ManualBtncancelMultiple" style="background-color: #00a8ca !important;" type="submit" @click="multipleDownload('Filler')">DOWNLOAD</button>
                    <button class="ManualBtn ManualBtncancelMultiple" style=" background-color: #d9534f !important" @click="confirmRemoveMultiplF(1)">DELETE</button>
                </div>
            </div>
            <!-- music -->
            <div class="library-item">
                <div class="line-item hovered-line">
                    <div class="left-item">
                        <div class="el">
                            <h3>Music</h3>
                        </div>
                        <div class="el" v-if="categoryHasErrors(library.music)">
                            <md-icon title="Music has errors" class="orange-color">error_outline</md-icon>
                        </div>
                    </div>
                    <div class="right-item">
                        <div>
                            <div class="el">
                                <md-button title="Upload Music" class="md-icon-button">
                                    <form id="musicForm" enctype="multipart/form-data" novalidate>
                                        <input type="hidden" name="category" value="story"/>
                                        <input class="file-input" name="files" type="file" multiple="multiple" @change="onFileUploadMulti($event, 'music')"/>
                                    </form>
                                    <md-icon>file_upload</md-icon>
                                </md-button>
                            </div>
                            <div class="el">
                                <md-button title="Open Music" class="md-icon-button" @click="toggleExpand('music')">
                                    <md-icon v-bind:class="[musicExpand ? 'icon-expand_more' : 'icon-expand_less']"></md-icon>
                                </md-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- music children -->
            <div class="inner-library-section slideDown" v-if="musicExpand">
                <md-checkbox v-model="selectAllCheckBoxMusic" @change="selectAllCheckEventMusic($event)" :value="1">SELECT All</md-checkbox>
                <div class="wrap-inner-line" v-for="(item, index) in library.music" v-if="filterCheck(index)">
                    <!-- music children languages -->
                    <div class="hidden-el open">
                        <div class="inner-line line-item hovered-line" v-for="el in item.media" :key="el.id">
                            <div class="el">
                                <md-checkbox v-model="arrayLibraryDetailsMusic" @change="checkBoxGetName($event,el.filename)" :attName="el.filename" :value="el.id"></md-checkbox>
                            </div>
                            <div class="left-item">
                                <div class="el indent">
                                    <h4 class="grey-color">
                                        <md-icon v-if="el.uploaded === true" title="File exists" class="green-color">done</md-icon>
                                        <md-icon v-else-if="el.uploaded === false" title="File is not in your library" class="red-color">cancel</md-icon>
                                        <i>{{ el.filename }}</i>
                                    </h4>
                                </div>
                                {{ el.file_length }}
                            </div>
                            <div v-if="el.file_length">
                                <div class="el" v-if="el.isVideo">
                                    <img @click="playMedia(el, 1)" class="imgAudioVideo" src="static/img/videoPlay.png"/>
                                </div>
                                <div class="el" v-else>
                                    <img @click="playMedia(el, 2)" class="imgAudioVideo" src="static/img/videoPlay.png"/>
                                </div>
                            </div>
                            <div class="right-item">
                                <div>
                                    <div class="el">
                                        <!-- <md-button title="Delete" class="md-icon-button delete-btn" @click="confirmRemove(el)">
                                          <md-icon class="icon-delete"></md-icon>
                                        </md-button> -->
                                    </div>
                                    <div class="el">
                                        <md-button aria-label="Settings menu" class="md-icon-button" v-if="false" :disabled="true">
                                            <form>
                                                <input class="file-input" type="file"/>
                                            </form>
                                            <md-icon>file_upload</md-icon>
                                        </md-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="shoMultiplemusic" style="float:right">
                    <button class="ManualBtn ManualBtncancelMultiple" style="background-color: #00a8ca !important;" type="submit" @click="multipleDownload('Music')">DOWNLOAD</button>
                    <button class="ManualBtn ManualBtncancelMultiple" style=" background-color: #d9534f !important" @click="confirmRemoveMultiplM(1)">DELETE</button>
                </div>
            </div>
            <!-- notification sounds -->
            <div class="library-item">
                <div class="line-item hovered-line">
                    <div class="left-item">
                        <div class="el">
                            <h3>Notification Sounds</h3>
                        </div>
                        <div class="el" v-if="categoryHasErrors(library.notification)">
                            <md-icon title="Notifications has errors" class="orange-color">error_outline</md-icon>
                        </div>
                    </div>
                    <div class="right-item">
                        <div>
                            <div class="el">
                                <md-button title="Upload Notification Sounds" class="md-icon-button">
                                    <form id="notificationForm" enctype="multipart/form-data" novalidate>
                                        <input type="hidden" name="category" value="story"/>
                                        <input class="file-input" type="file" name="files" multiple="multiple" @change="onFileUploadMulti($event, 'notification')"/>
                                    </form>
                                    <md-icon>file_upload</md-icon>
                                </md-button>
                            </div>
                            <div class="el">
                                <md-button title="Open Notification Sounds" class="md-icon-button" @click="toggleExpand('notification')">
                                    <md-icon v-bind:class="[notificationsExpand ? 'icon-expand_more' : 'icon-expand_less']"></md-icon>
                                </md-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- notification children -->
            <div class="inner-library-section slideDown" v-if="notificationsExpand">
                <md-checkbox v-model="selectAllCheckBoxNotification" @change="selectAllCheckEventNotification($event)" :value="1">SELECT All</md-checkbox>
                <div class="wrap-inner-line" v-for="(item, index) in library.notification" v-if="filterCheck(index)">
                    <!-- notifications children languages -->
                    <div class="hidden-el open">
                        <div class="inner-line line-item hovered-line" v-for="el in item.media" :key="el.id">
                            <div class="el">
                                <!-- {{arraListName}}        -->
                                <md-checkbox v-model="arrayLibraryDetailNotification" @change="checkBoxGetName($event,el.filename)" :attName="el.filename" :value="el.id"></md-checkbox>
                            </div>
                            <div class="left-item">
                                <div class="el indent">
                                    <h4 class="grey-color">
                                        <md-icon v-if="el.uploaded === true" title="File exists" class="green-color">done</md-icon>
                                        <md-icon v-else-if="el.uploaded === false" title="File is not in your library" class="red-color">cancel</md-icon>
                                        <i>{{ el.filename }}</i>
                                    </h4>
                                </div>
                                {{ el.file_length }}
                            </div>
                            <div v-if="el.file_length">
                                <div class="el" v-if="el.isVideo">
                                    <img @click="playMedia(el, 1)" class="imgAudioVideo" src="static/img/videoPlay.png"/>
                                </div>
                                <div class="el" v-else>
                                    <img @click="playMedia(el, 2)" class="imgAudioVideo" src="static/img/videoPlay.png"/>
                                </div>
                            </div>
                            <div class="right-item">
                                <div>
                                    <div class="el">
                                        <!-- <md-button title="Delete" class="md-icon-button delete-btn" @click="confirmRemove(el)">
                                          <md-icon class="icon-delete"></md-icon>
                                        </md-button> -->
                                    </div>
                                    <div class="el">
                                        <md-button aria-label="Settings menu" class="md-icon-button" v-if="false" :disabled="true">
                                            <form>
                                                <input class="file-input" type="file"/>
                                            </form>
                                            <md-icon>file_upload</md-icon>
                                        </md-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="shoMultiplenotification" style="float:right">
                    <button class="ManualBtn ManualBtncancelMultiple" style="background-color: #00a8ca !important;" type="submit" @click="multipleDownload('Notification')">DOWNLOAD</button>
                    <button class="ManualBtn ManualBtncancelMultiple" style=" background-color: #d9534f !important" @click="confirmRemoveMultiplN(1)">DELETE</button>
                </div>
            </div>
            <!-- safety -->
            <div class="library-item">
                <div class="line-item hovered-line">
                    <div class="left-item">
                        <div class="el">
                            <h3>Safety</h3>
                        </div>
                        <div class="el" v-if="categoryHasErrors(library.safety)">
                            <md-icon title="safety has errors" class="orange-color">error_outline</md-icon>
                        </div>
                    </div>
                    <div class="right-item">
                        <div>
                            <div class="el">
                                <md-button title="Upload Safety" class="md-icon-button ">
                                    <form id="safetyForm" enctype="multipart/form-data" novalidate>
                                        <input type="hidden" name="category" value="story"/>
                                        <input class="file-input" type="file" name="files" multiple="multiple" @change="onFileUploadMulti($event, 'safety')"/>
                                    </form>
                                    <md-icon>file_upload</md-icon>
                                </md-button>
                            </div>
                            <div class="el" v-if="safetyExpand">
                                <md-button class="md-icon-button" @click="toggleExpandAll('safety')">
                                    <md-icon v-bind:title="[expandAll['safety'] ? 'close all' : 'open all']">{{ expandAll['safety'] ? 'first_page' : 'last_page' }}</md-icon>
                                </md-button>
                            </div>
                            <div class="el">
                                <md-button title="Open Safety" class="md-icon-button" @click="toggleExpand('safety')">
                                    <md-icon v-bind:class="[safetyExpand ? 'icon-expand_more' : 'icon-expand_less']"></md-icon>
                                </md-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- safety children -->
            <div class="inner-library-section slideDown" v-if="safetyExpand">
                <draggable
                    :list="convertObjToSafety"
                    :disabled="!enabled"
                    class="list-group"
                    ghost-class="ghost"
                    :move="checkMove"
                    @update="onUpdate('Safety')"
                    @start="dragging = true"
                    @end="endDragging(false)"
                    title="Update sequence of story file"
                >
                    <md-checkbox v-model="selectAllCheckBoxSafety" @change="selectAllCheckEventSafety($event)" :value="1">SELECT All</md-checkbox>
                    <div class="wrap-inner-line" v-for="(item, index) in library.safety" v-if="filterCheck(index)">
                        <div class="inner-line" title="Update sequence for safety files">
                            <div class="line-item hovered-line no-outline-btn">
                                <div class="left-item">
                                    <div class="el">
                                        <h4>{{ index }}</h4>
                                    </div>
                                    <div class="el" v-if="hasVideo(item,'category')">
                                        <md-icon>videocam</md-icon>
                                    </div>
                                    <div class="el" v-if="friendlyNameHasErrors(item)">
                                        <md-icon title="This item has errors" class="orange-color">error_outline</md-icon>
                                    </div>
                                </div>
                                <div class="right-item">
                                    <div class="el time-el">
                                        <em></em>
                                    </div>
                                    <div>
                                        <div class="el" v-if="false">
                                            <md-button title="Delete" class="md-icon-button delete-btn top-index" :disabled="true">
                                                <md-icon class="icon-delete"></md-icon>
                                            </md-button>
                                        </div>
                                        <div class="el" v-if="false">
                                            <md-button aria-label="Settings menu" class="md-icon-button" :disabled="true">
                                                <form>
                                                    <input class="file-input" type="file"/>
                                                </form>
                                                <md-icon>file_upload</md-icon>
                                            </md-button>
                                        </div>
                                        <div class="el">
                                            <md-button aria-label="Open section" class="md-icon-button" @click="toggleLanguageExpand('safety', index)">
                                                <md-icon v-bind:class="[item.expanded ? 'icon-expand_more' : 'icon-expand_less']"></md-icon>
                                            </md-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- safety children languages -->
                        <div class="hidden-el" v-bind:class="[item.expanded ? 'open' : '']">
                            <div class="inner-line line-item hovered-line" v-for="el in item.media" :key="el.id">
                                <div class="el">
                                    <!-- {{arraListName}}        -->
                                    <md-checkbox v-model="arrayLibraryDetailsafety" @change="checkBoxGetName($event,el.filename)" :attName="el.filename" :value="el.id"></md-checkbox>
                                </div>
                                <div class="left-item">
                                    <div class="el indent">
                                        <h4 class="grey-color">
                                            <md-icon v-if="el.uploaded === true" title="File exists" class="green-color">done</md-icon>
                                            <md-icon v-else-if="el.uploaded === false" title="File is not in your library" class="red-color">cancel</md-icon>
                                            <i>{{ el.filename }}</i>
                                        </h4>
                                    </div>
                                    <div class="el" v-if="hasVideo(el,'file')">
                                        <md-icon>videocam</md-icon>
                                    </div>
                                    <div class="el" v-else>
                                        <md-icon></md-icon>
                                    </div>
                                    {{ el.file_length }}
                                </div>
                                <div v-if="el.file_length">
                                    <div class="el" v-if="el.isVideo">
                                        <img @click="playMedia(el, 1)" class="imgAudioVideo" src="static/img/videoPlay.png"/>
                                    </div>
                                    <div class="el" v-else>
                                        <img @click="playMedia(el, 2)" class="imgAudioVideo" src="static/img/videoPlay.png"/>
                                    </div>
                                </div>
                                <div class="right-item">
                                    <div>
                                        <div class="el">
                                            <!-- <div  class="el logout-button">
                                               <button data-v-0c732d5c=""  @click="addFileWithRoute(el.id)" type="button" class="md-button md-theme-default">
                                                 <div class="md-ripple">
                                                   <span class="md-button-content cssForAddLibrray">Add Library File To A Route</span>
                                                 </div>
                                               </button>
                                             </div> -->
                                            <!-- <md-button title="Delete" class="md-icon-button delete-btn" @click="confirmRemove(el)">
                                              <md-icon class="icon-delete"></md-icon>
                                            </md-button> -->
                                        </div>
                                        <div class="el">
                                            <md-button aria-label="Settings menu" class="md-icon-button upload-btn" v-if="false" :disabled="true">
                                                <form>
                                                    <input class="file-input" type="file"/>
                                                </form>
                                                <md-icon>file_upload</md-icon>
                                            </md-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </draggable>
                <div v-if="shoMultiplesafety" style="float:right">
                    <button class="ManualBtn ManualBtncancelMultiple" style="background-color: #00a8ca !important;" type="submit" @click="multipleDownload('Safety')">DOWNLOAD</button>
                    <button class="ManualBtn ManualBtncancelMultiple" style=" background-color: #d9534f !important" @click="confirmRemoveMultiplS(1)">DELETE</button>
                </div>
            </div>
            <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDialog" class="uplado_medaia_acroller">
                <header><b><h2>Uploading File(s) to Cortex</h2></b></header>
                <div class="modal-body">
                    <div class="table-wrapper">
                        <table class="fillupload-table">
                            <thead>
                            <tr>
                                <th style="width: 5%"></th>
                                <th style="width: 25%">File Name</th>
                                <th style="width: 30%">Status</th>
                                <th style="width: 40%">Message</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(uploadFile, index) in uploadFiles" :key="index">
                                <td>
                                    <md-icon :class="uploadFile.iconInfo.color">{{ uploadFile.iconInfo.icon }}</md-icon>
                                </td>
                                <td>
                                    <div class="up-filename">{{ uploadFile.name }}</div>
                                </td>
                                <td>
                                    <div class="progress" :class="uploadFile.progressBarColor">
                                        <div :class="uploadFile.progressBarColor" :style="{width:uploadFile.progress + '%'}" class="progress-bar">
                                            <span style="font-weight:600;">{{ uploadFile.progressBarMessage }}</span>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="e-message">{{ uploadFile.failureMessage }}</div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="modal-footer">
                    <md-dialog-actions class="full-btn">
                        <md-button class="md-raised md-primary" @click="closeDialog" :disabled="disableCloseButtonOnFileUploadModal">close</md-button>
                    </md-dialog-actions>
                </div>
            </md-dialog>
            <md-dialog :md-click-outside-to-close="false" :md-active.sync="showValidateDialog">
                <header>
                    <h2>Validate Library</h2>
                </header>
                <div class="fill-modal">
                    <div v-if="isUploading" class="upload-text centered">
                        Uploading File(s) to Cortex
                    </div>
                    <div v-if="isValidating" class="upload-text centered">
                        Validating library files ...
                    </div>
                    <div v-else-if="!isValidating" class="upload-text centered">
                        Your library has been validated
                    </div>
                    <div class="loading-icon">
                        <md-progress-spinner v-if="isValidating" class="md-accent export-running-spinner" :md-diameter="30" md-mode="indeterminate"></md-progress-spinner>
                    </div>
                </div>
                <md-dialog-actions class="full-btn">
                    <md-button class="md-raised md-primary" @click="closeValidateDialog" :disabled="isValidating">close</md-button>
                </md-dialog-actions>
            </md-dialog>
        </div>
        <modal name="video-file-play" :resizable="true" class="full-size-video">
            <div class="row">
                <div class="md-dialog-container" tabindex="-1">
                    <div class="boxes" tabindex="-1">
                        <video ref="videoRef" v-bind:src="this.vedioSrc" id="video-container" width="100%" controls></video>
                    </div>
                </div>
            </div>
        </modal>
        <modal name="audio-file-play" :resizable="true">
            <div class="row">
                <div class="md-dialog-container" tabindex="-1">
                    <div class="boxes" tabindex="-1">
                        <audio-player class="audioFile" :file="file1"></audio-player>
                    </div>
                </div>
            </div>
        </modal>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDeleteDialog">
            <md-dialog-title>
                Confirm Delete
            </md-dialog-title>
            <md-dialog-content>
                Do you want to delete this Media?
            </md-dialog-content>
            <md-dialog-actions class="full-btn">
                <md-button class="ManualBtn ManualBtndelete" @click="deleteMedia (libraryItemDelete)">DELETE</md-button>
                <!-- <md-button class="ManualBtn ManualBtncancel" @click="showDeleteDialog = false">Cancel</md-button> -->
                <button class="ManualBtn ManualBtncancel extraClass" @click="showDeleteDialog = false">CANCEL</button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDeleteDialogMultiple">
            <md-dialog-title>
                Confirm Delete
            </md-dialog-title>
            <md-dialog-content>
                Do you want to delete this Media?
            </md-dialog-content>
            <md-dialog-actions class="full-btn">
                <md-button class="ManualBtn ManualBtndelete" @click="deleteMediaMultiple (arrayLibraryDetails)">DELETE</md-button>
                <button class="ManualBtn ManualBtncancel extraClass" @click="showDeleteDialogMultiple = false">CANCEL</button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showMaxFileUplaodError">
            <md-dialog-title>
                Important Information
            </md-dialog-title>
            <md-dialog-content>
              You can only upload 20 files at a time
            </md-dialog-content>
            <md-dialog-actions class="full-btn">
                <md-button class="ManualBtn ManualBtncancel" @click="showMaxFileUplaodError = false">Ok</md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDeleteDialogMultipleF">
            <md-dialog-title>
                Confirm Delete
            </md-dialog-title>
            <md-dialog-content>
                Do you want to delete this Media?
            </md-dialog-content>
            <md-dialog-actions class="full-btn">
                <md-button class="ManualBtn ManualBtndelete" @click="deleteMediaMultiplefiller (arrayLibraryDetailsFiller)">DELETE</md-button>
                <button class="ManualBtn ManualBtncancel extraClass" @click="showDeleteDialogMultipleF = false">CANCEL</button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDeleteDialogMultipleM">
            <md-dialog-title>
                Confirm Delete
            </md-dialog-title>
            <md-dialog-content>
                Do you want to delete this Media?
            </md-dialog-content>
            <md-dialog-actions class="full-btn">
                <md-button class="ManualBtn ManualBtndelete" @click="deleteMediaMultiplemusic (arrayLibraryDetailsMusic)">DELETE</md-button>
                <button class="ManualBtn ManualBtncancel extraClass" @click="showDeleteDialogMultipleM = false">CANCEL</button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDeleteDialogMultipleN">
            <md-dialog-title>
                Confirm Delete
            </md-dialog-title>
            <md-dialog-content>
                Do you want to delete this Media?
            </md-dialog-content>
            <md-dialog-actions class="full-btn">
                <md-button class="ManualBtn ManualBtndelete" @click="deleteMediaMultiplenotification (arrayLibraryDetailNotification)">DELETE</md-button>
                <button class="ManualBtn ManualBtncancel extraClass" @click="showDeleteDialogMultipleN = false">CANCEL</button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDeleteDialogMultilesafety">
            <md-dialog-title>
                Confirm Delete
            </md-dialog-title>
            <md-dialog-content>
                Do you want to delete this Media?
            </md-dialog-content>
            <md-dialog-actions class="full-btn">
                <md-button class="ManualBtn ManualBtndelete" @click="deleteMediaMultiplesafety (arrayLibraryDetailsafety)">DELETE</md-button>
                <button class="ManualBtn ManualBtncancel extraClass" @click="showDeleteDialogMultilesafety = false">CANCEL</button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog :md-active.sync="showDialogAllRoute" style="overflow-y: scroll;">
            <md-list class="full-control">
                <md-subheader>Routes</md-subheader>
                <md-list-item v-for="(route, index) in arrayAllRoute" :key="index">
                    <md-checkbox v-model="selectClient" :value="route.id">{{ route.name }}({{ route.toursName }})</md-checkbox>
                </md-list-item>
                <md-button class="ManualBtn ManualBtncancel" @click="addLibraryFileToRoute(tempArray.libraryID)">ADD</md-button>
            </md-list>
        </md-dialog>
    </div>
</template>

<script>
import axios from 'axios';
import {mapActions, mapGetters} from 'vuex';
import {multipleDownloadFunction} from '../../services/ClientService.js';
import draggable from 'vuedraggable';
import {addFileWithRouteApi, addLibraryFileToRouteApi, getSignedUrlForLibraryItem} from '../../services/LibraryService.js';

const convertTimeHHMMSS = (val) => {
  let hhmmss = new Date(val * 1000).toISOString().substr(11, 8);
  return hhmmss.indexOf('00:') === 0 ? hhmmss.substr(3) : hhmmss;
};
const AudioPlayer = {
  template: `
        <div class="player">
        <div class="player-controls">
            <div><a v-on:click.prevent="stop" title="Stop" href="#">
                <svg width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path fill="currentColor" d="M16,4.995v9.808C16,15.464,15.464,16,14.804,16H4.997C4.446,16,4,15.554,4,15.003V5.196C4,4.536,4.536,4,5.196,4h9.808C15.554,4,16,4.446,16,4.995z"/>
                </svg>
            </a></div>
            <div><a v-on:click.prevent="playing = !playing" title="Play/Pause" href="#">
                <svg width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path v-if="!playing" fill="currentColor" d="M15,10.001c0,0.299-0.305,0.514-0.305,0.514l-8.561,5.303C5.51,16.227,5,15.924,5,15.149V4.852c0-0.777,0.51-1.078,1.135-0.67l8.561,5.305C14.695,9.487,15,9.702,15,10.001z"/>
                    <path v-else fill="currentColor" d="M15,3h-2c-0.553,0-1,0.048-1,0.6v12.8c0,0.552,0.447,0.6,1,0.6h2c0.553,0,1-0.048,1-0.6V3.6C16,3.048,15.553,3,15,3z M7,3H5C4.447,3,4,3.048,4,3.6v12.8C4,16.952,4.447,17,5,17h2c0.553,0,1-0.048,1-0.6V3.6C8,3.048,7.553,3,7,3z"/>
                </svg>
            </a></div>
            <div>
                <div v-on:click="seek" class="player-progress" title="Time played : Total time">
                    <div :style="{ width: this.percentComplete + '%' }" class="player-seeker"></div>
                </div>
                <div class="player-time">
                    <div class="player-time-current">{{ currentTime }}</div>
                    <div class="player-time-total">{{ durationTime }}</div>
                </div>
            </div>
            <div><a v-on:click.prevent="download" href="#">
                <svg width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path fill="currentColor" d="M15,7h-3V1H8v6H5l5,5L15,7z M19.338,13.532c-0.21-0.224-1.611-1.723-2.011-2.114C17.062,11.159,16.683,11,16.285,11h-1.757l3.064,2.994h-3.544c-0.102,0-0.194,0.052-0.24,0.133L12.992,16H7.008l-0.816-1.873c-0.046-0.081-0.139-0.133-0.24-0.133H2.408L5.471,11H3.715c-0.397,0-0.776,0.159-1.042,0.418c-0.4,0.392-1.801,1.891-2.011,2.114c-0.489,0.521-0.758,0.936-0.63,1.449l0.561,3.074c0.128,0.514,0.691,0.936,1.252,0.936h16.312c0.561,0,1.124-0.422,1.252-0.936l0.561-3.074C20.096,14.468,19.828,14.053,19.338,13.532z"/>
                </svg>
            </a></div>
            <div><a v-on:click.prevent="innerLoop = !innerLoop" href="#">
                <svg width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path v-if="!innerLoop" fill="currentColor" d="M1,12V5h3v6h10V8l5,4.5L14,17v-3H3C1.895,14,1,13.104,1,12z"/>
                    <path v-else fill="currentColor" d="M20,7v7c0,1.103-0.896,2-2,2H2c-1.104,0-2-0.897-2-2V7c0-1.104,0.896-2,2-2h7V3l4,3.5L9,10V8H3v5h14V8h-3V5h4C19.104,5,20,5.896,20,7z"/>
                </svg>
            </a></div>
            <div><a v-on:click.prevent="mute" title="Mute" href="#">
                <svg width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path v-if="!muted" fill="currentColor" d="M5.312,4.566C4.19,5.685-0.715,12.681,3.523,16.918c4.236,4.238,11.23-0.668,12.354-1.789c1.121-1.119-0.335-4.395-3.252-7.312C9.706,4.898,6.434,3.441,5.312,4.566z M14.576,14.156c-0.332,0.328-2.895-0.457-5.364-2.928C6.745,8.759,5.956,6.195,6.288,5.865c0.328-0.332,2.894,0.457,5.36,2.926C14.119,11.258,14.906,13.824,14.576,14.156zM15.434,5.982l1.904-1.906c0.391-0.391,0.391-1.023,0-1.414c-0.39-0.391-1.023-0.391-1.414,0L14.02,4.568c-0.391,0.391-0.391,1.024,0,1.414C14.41,6.372,15.043,6.372,15.434,5.982z M11.124,3.8c0.483,0.268,1.091,0.095,1.36-0.388l1.087-1.926c0.268-0.483,0.095-1.091-0.388-1.36c-0.482-0.269-1.091-0.095-1.36,0.388L10.736,2.44C10.468,2.924,10.642,3.533,11.124,3.8z M19.872,6.816c-0.267-0.483-0.877-0.657-1.36-0.388l-1.94,1.061c-0.483,0.268-0.657,0.878-0.388,1.36c0.268,0.483,0.877,0.657,1.36,0.388l1.94-1.061C19.967,7.907,20.141,7.299,19.872,6.816z"/>
                    <path v-else fill="currentColor" d="M14.201,9.194c1.389,1.883,1.818,3.517,1.559,3.777c-0.26,0.258-1.893-0.17-3.778-1.559l-5.526,5.527c4.186,1.838,9.627-2.018,10.605-2.996c0.925-0.922,0.097-3.309-1.856-5.754L14.201,9.194z M8.667,7.941c-1.099-1.658-1.431-3.023-1.194-3.26c0.233-0.234,1.6,0.096,3.257,1.197l1.023-1.025C9.489,3.179,7.358,2.519,6.496,3.384C5.568,4.31,2.048,9.261,3.265,13.341L8.667,7.941z M18.521,1.478c-0.39-0.391-1.023-0.391-1.414,0L1.478,17.108c-0.391,0.391-0.391,1.024,0,1.414c0.391,0.391,1.023,0.391,1.414,0l15.629-15.63C18.912,2.501,18.912,1.868,18.521,1.478z"/>
                </svg>
            </a></div>
            <div><a v-on:click.prevent="" v-on:mouseenter="showVolume = true" title="Volume" href="#">
                <svg width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path fill="currentColor" d="M19,13.805C19,14.462,18.462,15,17.805,15H1.533c-0.88,0-0.982-0.371-0.229-0.822l16.323-9.055C18.382,4.67,19,5.019,19,5.9V13.805z"/>
                </svg>
                <input v-model.lazy.number="volume" v-show="showVolume" type="range" min="0" max="100"/></a></div>
        </div>
        <audio :loop="innerLoop" ref="audiofile" :src="file" preload="auto" style="display: none;"></audio>
        </div>`,
  props: {
    file: {
      type: String,
      default: null
    },
    autoPlay: {
      type: Boolean,
      default: false
    },
    loop: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    audio: undefined,
    currentSeconds: 0,
    durationSeconds: 0,
    innerLoop: false,
    loaded: false,
    playing: false,
    previousVolume: 35,
    showVolume: false,
    volume: 100
  }),
  computed: {
    currentTime () {
      return convertTimeHHMMSS(this.currentSeconds);
    },
    durationTime () {
      return convertTimeHHMMSS(this.durationSeconds);
    },
    percentComplete () {
      return parseInt(this.currentSeconds / this.durationSeconds * 100);
    },
    muted () {
      return this.volume / 100 === 0;
    }
  },
  watch: {
    playing (value) {
      if (value) {
        return this.audio.play();
      }
      this.audio.pause();
    },
    volume (value) {
      this.showVolume = false;
      this.audio.volume = this.volume / 100;
    }
  },
  methods: {
    download () {
      this.stop();
      window.open(this.file, 'download');
    },
    load () {
      if (this.audio.readyState >= 2) {
        this.loaded = true;
        this.durationSeconds = parseInt(this.audio.duration);
        this.playing = this.autoPlay;
      }
      throw new Error('Failed to load sound file.');
    },
    mute () {
      if (this.muted) {
        this.volume = this.previousVolume;
      }

      this.previousVolume = this.volume;
      this.volume = 0;
    },
    seek (e) {
      if (!this.playing || e.target.tagName === 'SPAN') {
        return;
      }
      const el = e.target.getBoundingClientRect();
      const seekPos = (e.clientX - el.left) / el.width;
      this.audio.currentTime = parseInt(this.audio.duration * seekPos);
    },
    stop () {
      this.playing = false;
      this.audio.currentTime = 0;
    },
    update (e) {
      this.currentSeconds = parseInt(this.audio.currentTime);
    }
  },
  created () {
    this.innerLoop = this.loop;
  },
  mounted () {
    this.audio = this.$el.querySelectorAll('audio')[0];
    this.audio.addEventListener('timeupdate', this.update);
    this.audio.addEventListener('loadeddata', this.load);
    this.audio.addEventListener('pause', () => {
      this.playing = false;
    });
    this.audio.addEventListener('play', () => {
      this.playing = true;
    });
  }
};

export default {
  data () {
    return {
      showMaxFileUplaodError: false,
      arrayLibraryDetails: [],
      arrayLibraryDetailsFiller: [],
      arrayLibraryDetailsMusic: [],
      arrayLibraryDetailNotification: [],
      arrayLibraryDetailsafety: [],
      arraListName: [],
      selectAllCheckBoxFiller: [],
      selectAllCheckBoxMusic: [],
      selectAllCheckBoxNotification: [],
      selectAllCheckBoxSafety: [],
      selectAllCheckBox: [],
      shoMultiple: false,
      shoMultiplefiller: false,
      shoMultiplemusic: false,
      shoMultiplenotification: false,
      shoMultiplesafety: false,
      isActive: false,
      isLoadingmy: false,
      libraryItemDelete: '',
      showDeleteDialog: false,
      showDeleteDialogMultiple: false,
      showDeleteDialogMultipleF: false,
      showDeleteDialogMultipleM: false,
      showDeleteDialogMultipleN: false,
      showDeleteDialogMultilesafety: false,
      storiesExpand: false,
      fillersExpand: false,
      musicExpand: false,
      notificationsExpand: false,
      safetyExpand: false,
      expandAll: {
        story: false,
        filler: false,
        music: false,
        notification: false,
        safety: false
      },
      filterString: '',
      file: null,
      files: [],
      vedioSrc: '',
      percentCompleted: 0,
      showDialog: false,
      showValidateDialog: false,
      validationError: null,
      storageFileUrl: '',
      file1: '',
      enabled: true,
      librarystory: [],
      dragging: false,
      showDialogAllRoute: false,
      arrayAllRoute: [],
      routeId: '',
      tempArray: [],
      selectClient: [],
      dataForPost: '',
      ArrayinUse: [],
      duplicateContent: true,
      showLoader: false,
      uploadFiles: [],
      disableCloseButtonOnFileUploadModal: true,
      maxUploaidingFileLimit: 20
    };
  },
  components: {
    AudioPlayer,
    draggable
  },
  watch: {
    arrayLibraryDetails () {
      if (this.arrayLibraryDetails.length > 0) {
        this.shoMultiple = true;
      } else {
        this.shoMultiple = false;
      }
    },
    arrayLibraryDetailsFiller () {
      if (this.arrayLibraryDetailsFiller.length > 0) {
        this.shoMultiplefiller = true;
      } else {
        this.shoMultiplefiller = false;
      }
    },
    arrayLibraryDetailsMusic () {
      if (this.arrayLibraryDetailsMusic.length > 0) {
        this.shoMultiplemusic = true;
      } else {
        this.shoMultiplemusic = false;
      }
    },
    arrayLibraryDetailNotification () {
      if (this.arrayLibraryDetailNotification.length > 0) {
        this.shoMultiplenotification = true;
      } else {
        this.shoMultiplenotification = false;
      }
    },
    arrayLibraryDetailsafety () {
      if (this.arrayLibraryDetailsafety.length > 0) {
        this.shoMultiplesafety = true;
      } else {
        this.shoMultiplesafety = false;
      }
    },
    uploadFiles: {
      deep: true,
      handler (uploadFiles) {
        let refreshFilesInLibrary = true;
        uploadFiles.forEach((file, index) => {
          if (!file.message) {
            refreshFilesInLibrary = false;
          }
          let iconInfo = this.getUploadedFileIcon(file);
          this.uploadFiles[index].iconInfo.icon = iconInfo.icon;
          this.uploadFiles[index].iconInfo.color = iconInfo.color;
          this.uploadFiles[index].failureMessage = this.getUploadedFileFailureMessage(file);
          this.uploadFiles[index].progressBarColor = this.getUploadedFileProgressBarColor(file);
          this.uploadFiles[index].progressBarMessage = this.getUploadedFileProgressBarMessage(file);
        });
        if (refreshFilesInLibrary) {
          this.library = this.loadLibrary(this.currentClient.id);
          this.disableCloseButtonOnFileUploadModal = false;
        }
      }
    }
  },
  computed: {
    ...mapGetters('client', ['currentClient']),
    ...mapGetters('library', {library: 'getLibrary', isUploading: 'isUploading', isValidating: 'isValidating', results: 'uploadResults', uploadError: 'getUploadError'}),
    ...mapGetters('user', ['isAdmin']),
    convertObjToStory () {
      var obj = this.library.story;
      var array = Object.entries(obj).map(([key, value]) => ({[key]: value}));
      return array;
    },
    convertObjToSafety () {
      var obj = this.library.safety;
      var array = Object.entries(obj).map(([key, value]) => ({[key]: value}));
      return array;
    },
    convertObjToFiller () {
      var obj = this.library.filler;
      var array = Object.entries(obj).map(([key, value]) => ({[key]: value}));
      return array;
    },
    filterStringIsEmpty () {
      if (this.filterString.length === 0) {
        this.filterString = '';
      }
      if (this.filterString.length > 0) {
        return this.filterString.replace(/^\s+|\s+$/g, '').length === 0;
      }
    },
    fileName () {
      if (this.file.name) {
        return this.file.name;
      } else {
        return 'NULL';
      }
    },
    resultsSuccessesAndFails () {
      let successes = 0;
      let fails = 0;
      let swaps = 0;
      let duplicate = 0;
      let diffCategory = '';
      if (this.results) {
        if (this.results.sameFileDiff === 1) {
          duplicate = duplicate + 1;
          diffCategory = this.results.diffCategory;
        } else {
          for (let [value] of Object.entries(this.results)) {
            if (this.results[value] === 'uploaded') {
              successes = successes + 1;
            } else if (this.results[value] === 'replaced') {
              swaps = swaps + 1;
            } else if (this.results[value] === 'File bitrate is greater than 128kbps please upload different file.' || this.results[value] === '=> File prefix does not match' || this.results[value] === 'diffCategory') {
              fails = fails + 1;
            } else if (this.results[value] === 'failed') {
              fails = fails + 1;
            } else if (this.results === '1') {
              duplicate = duplicate + 1;
            } else if (this.validationError) {
              fails = fails + 1;
            } else {
              swaps = swaps + 1;
            }
          }
        }
      }
      if (this.results.sameFileUpdated === 1) {
        return 'File Overwrite Successfully';
      }
      if (this.results.bitRateFalse === 1) {
        return 'File bitrate is greater than 128kbps please upload different file. ';
      }
      let successText = '';
      let failText = '';
      let swapText = '';
      if (successes === 1) {
        successText = successes + ' file added, ';
      } else {
        successText = successes + ' files added, ';
      }
      if (swaps === 1) {
        swapText = swaps + ' file overwritten and ';
      } else {
        swapText = swaps + ' files overwritten and ';
      }
      if (fails === 1) {
        failText = fails + ' file failed.';
      } else {
        failText = fails + ' files failed.';
      }
      if (duplicate === 1) {
        console.log(diffCategory);
      } else {
        return successText + swapText + failText;
      }
    }
  },
  methods: {
    ...mapActions('library', ['forceLanguageOpen', 'loadLibrary', 'loadLibraryAndValidate', 'removeFromLibrary', 'removeFromLibraryMultiple', 'toggleExpandLanguages', 'toggleExpandLanguagesAll', 'clearUploadResults', 'reorderLibrary']),
    ...mapActions('file', ['uploadFile', 'uploadFiles']),
    checkMove: function (e) {
      window.console.log('Future index: ' + e.draggedContext.futureIndex);
    },
    endDragging (dragging) {
      dragging = false;
    },
    selectAllCheckEvent (event) {
      if (event.length === 1) {
        var item;
        let item2;
        for (item in this.library.story) {
          for (item2 in this.library.story[item].media) {
            let id = this.library.story[item].media[item2].id;
            this.arrayLibraryDetails.push(id);
          }
        }
      } else {
        this.arrayLibraryDetails = [];
      }
    },
    selectAllCheckEventFiller (event) {
      if (event.length === 1) {
        var itemf;
        let item2f;
        for (itemf in this.library.filler) {
          for (item2f in this.library.filler[itemf].media) {
            let id = this.library.filler[itemf].media[item2f].id;
            this.arrayLibraryDetailsFiller.push(id);
          }
        }
      } else {
        this.arrayLibraryDetailsFiller = [];
      }
    },
    selectAllCheckEventMusic (event) {
      if (event.length === 1) {
        var itemf;
        let item2f;
        for (itemf in this.library.music) {
          for (item2f in this.library.music[itemf].media) {
            let id = this.library.music[itemf].media[item2f].id;
            this.arrayLibraryDetailsMusic.push(id);
          }
        }
      } else {
        this.arrayLibraryDetailsMusic = [];
      }
    },
    selectAllCheckEventNotification (event) {
      if (event.length === 1) {
        var itemf;
        let item2f;
        for (itemf in this.library.notification) {
          for (item2f in this.library.notification[itemf].media) {
            let id = this.library.notification[itemf].media[item2f].id;
            this.arrayLibraryDetailNotification.push(id);
          }
        }
      } else {
        this.arrayLibraryDetailNotification = [];
      }
    },
    selectAllCheckEventSafety (event) {
      if (event.length === 1) {
        var itemf;
        let item2f;
        for (itemf in this.library.safety) {
          for (item2f in this.library.safety[itemf].media) {
            let id = this.library.safety[itemf].media[item2f].id;
            this.arrayLibraryDetailsafety.push(id);
          }
        }
      } else {
        this.arrayLibraryDetailsafety = [];
      }
    },
    inArray: function (needle, haystack) {
      var length = haystack.length;
      for (var i = 0; i < length; i++) {
        if (haystack[i] === needle) return true;
      }
      return false;
    },
    multipleDownload (libraryItem) {
      let mediaNmae = libraryItem;
      if (libraryItem === 'STORY') {
        libraryItem = this.arrayLibraryDetails;
      } else if (libraryItem === 'Filler') {
        libraryItem = this.arrayLibraryDetailsFiller;
      } else if (libraryItem === 'Music') {
        libraryItem = this.arrayLibraryDetailsMusic;
      } else if (libraryItem === 'Notification') {
        libraryItem = this.arrayLibraryDetailNotification;
      } else if (libraryItem === 'Safety') {
        libraryItem = this.arrayLibraryDetailsafety;
      }
      multipleDownloadFunction({
        'clientId': this.currentClient.id,
        'libraryItemId': libraryItem,
        'mediaNmae': mediaNmae
      }).then((responce) => {
        var i = 0;

        function myLoop (responce) {
          let urlTemp = responce.data[i].mediaLink;
          var filename = responce.data[i].filename;
          axios.get(urlTemp, {responseType: 'blob'})
            .then(response => {
              const blob = new Blob([response.data], {type: 'application/pdf'});
              const link = document.createElement('a');
              link.href = URL.createObjectURL(blob);
              link.download = filename;
              link.click();
              URL.revokeObjectURL(link.href);
            });
          i++;
          if (i < responce.data.length) {
            myLoop(responce);
          }
        }

        myLoop(responce);
      });
    },
    checkBoxGetName (event, name) {
      if (event.length !== 0) {
        this.arraListName.push(name);
      }
      if (event.length === 0) {
        this.arraListName = [];
      }
    },
    downloadPdf () {
      let pp = this;
      axios.post('api/multMediaFileDownload').then((response) => {
        for (let index = 0; index < pp.arraListName.length; index++) {
          let a = document.createElement('a');
          document.body.appendChild(a);
          a.style = 'display: none';
          // Create a blob from the response data, and create a download url for it
          let blob = new Blob([response.data]);
          let url = window.URL.createObjectURL(blob);
          // Set the link to the download url, give it the proper appdata name, and click it
          a.href = url;
          a.download = pp.arraListName[index];
          a.click();
        }
        pp.arraListName = [];
      });
    },
    onUpdate (cate) {
      this.isLoadingmy = true;
      this.savelistStoryOrder(cate);
    },
    async savelistStoryOrder (cate) {
      if (cate === 'Filler') {
        this.ArrayinUse = this.convertObjToFiller;
      } else {
        this.ArrayinUse = this.convertObjToSafety;
      }
      this.reorderLibrary({
        'clientId': this.currentClient.id,
        'newArray': this.ArrayinUse,
        'cate': cate
      }).then(() => {
        this.isLoadingmy = false;
      });
    },
    addFileWithRoute (libraryID) {
      this.tempArray['libraryID'] = libraryID;
      addFileWithRouteApi().then(response => {
        this.arrayAllRoute = response.data;
      }).catch(function (error) {
        console.log('erros : ', error);
      });
      this.showDialogAllRoute = true;
    },
    addLibraryFileToRoute (libraryID) {
      this.dataForPost = {
        'libraryId': libraryID,
        'routeID': this.selectClient
      };
      addLibraryFileToRouteApi(this.dataForPost).then(response => {
        this.showDialogAllRoute = false;
      }).catch(function (error) {
        console.log('erros : ', error);
      });
    },
    hasVideo (story, heading) {
      let hasVid = false;
      if (heading === 'category') {
        for (let file = 0; file < story.media.length; file++) {
          if (story.media[file].isVideo === 1) {
            hasVid = true;
          }
        }
      } else if (heading === 'file' && story.isVideo === 1) {
        hasVid = true;
      }
      return hasVid;
    },
    getFilesSize () {
      this.upload_size = 0;
      this.files.map((item) => {
        this.upload_size += parseInt(item.size);
      });
      this.upload_size = Number((this.upload_size).toFixed(1));
      this.$forceUpdate();
    },
    toggleExpand (type) {
      if (type === 'story') {
        this.storiesExpand = !this.storiesExpand;
      } else if (type === 'filler') {
        this.fillersExpand = !this.fillersExpand;
      } else if (type === 'music') {
        this.musicExpand = !this.musicExpand;
      } else if (type === 'notification') {
        this.notificationsExpand = !this.notificationsExpand;
      } else if (type === 'safety') {
        this.safetyExpand = !this.safetyExpand;
      }
    },
    toggleExpandAll (type) {
      this.expandAll[type] = !this.expandAll[type];
      this.toggleExpandLanguagesAll({'category': type, 'expand': this.expandAll[type]});
    },
    toggleLanguageExpand (category, index) {
      this.toggleExpandLanguages({'category': category, 'index': index});
    },
    forceOpen (category, index) {
      this.forceLanguageOpen({'category': category, 'index': index});
    },
    filterCheck (text) {
      let passesFilter = true;
      if (!this.filterStringIsEmpty) {
        if (this.filterString.length > 0) {
          if (this.filterString && this.filterString.trim().length) {
            passesFilter = (text.toLowerCase()).includes(this.filterString.toLowerCase());
          }
        }
      }
      return passesFilter;
    },
    onFileUpload (evt, category) {
      this.file = evt.target.files[0];
      let data = new FormData();
      data.append('clientId', this.currentClient.id);
      data.append('category', category);
      data.append('file', this.file);
      this.uploadFile(data);
      this.showDialog = true;
    },
    async onFileUploadMulti (event, category) {
      this.showDialog = this.disableCloseButtonOnFileUploadModal = true;

      this.uploadFiles = [];
      const files = event.target.files;
      if (!files.length) {
        return false;
      }
      if (files.length > this.maxUploaidingFileLimit) {
        this.showMaxFileUplaodError = true;
        this.showDialog = this.disableCloseButtonOnFileUploadModal = false;
        return false;
      }

      for (let i = 0; i < files.length; i++) {
        let uploadFile = {
          name: files[i].name,
          progress: 0,
          message: '',
          iconInfo: {
            icon: '',
            color: ''
          },
          failureMessage: '',
          progressBarColor: '',
          progressBarMessage: ''
        };

        this.uploadFiles.push(uploadFile);
      }

      for (let i = 0; i < files.length; i++) {
        let formData = new FormData();
        formData.append('clientId', this.currentClient.id);
        formData.append('category', category);
        formData.append('files[]', files[i]);

        let config = {
          onUploadProgress: (progressEvent) => {
            this.uploadFiles[i].progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          }
        };
        let res = await axios.post('api/client/' + this.currentClient.id + '/files/upload', formData, config);
        if (res.status === 200) {
          this.uploadFiles[i].message = Object.values(res.data)[0];
        }
      }
      event.target.form.reset();
      // previous code
      // Array.prototype.forEach.call(files, (file, index) => {
      //   let formData = new FormData();
      //   formData.append('clientId', this.currentClient.id);
      //   formData.append('category', category);
      //   formData.append('files[]', file);

      //   let uploadFile = {
      //     name: file.name,
      //     progress: 0,
      //     message: '',
      //     iconInfo: {
      //       icon: '',
      //       color: ''
      //     },
      //     failureMessage: '',
      //     progressBarColor: '',
      //     progressBarMessage: ''
      //   };

      //   this.uploadFiles.push(uploadFile);
      //   console.log('uploadfile',this.uploadFile);
      //   console.log('formData', formData);

      //    let config = {
      //     onUploadProgress: (progressEvent) => {
      //       uploadFiles[index].progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      //     }
      //   };
      //   // axios.post('api/client/' + this.currentClient.id + '/files/upload', formData, config).then((response) => {
      //   //   uploadFiles[index].message = Object.values(response.data)[0];
      //   // }).catch((error) => {
      //   //   console.log(error.response.data);
      //   // });
      // });
      // event.target.form.reset();
    },
    getUploadedFileIcon (file) {
      let iconInfo = {
        icon: '',
        color: ''
      };

      if (!file.message) {
        return iconInfo;
      }

      switch (file.message) {
        case 'uploaded':
          iconInfo.icon = 'done';
          iconInfo.color = 'green';
          break;
        case 'replaced':
          iconInfo.icon = 'refresh';
          iconInfo.color = 'green';
          break;
        default:
          iconInfo.icon = 'cancel';
          iconInfo.color = 'red';
          break;
      }
      return iconInfo;
    },
    getUploadedFileFailureMessage (file) {
      let failureMessage = '';
      if (!file.message) {
        return failureMessage;
      }
      switch (file.message) {
        case 'failed':
          failureMessage = 'The file is not valid. Valid characters are [a-z][A-Z][0-9][ _]';
          break;
        case 'fail':
          failureMessage = 'The file is not valid. Incorrect file format.';
          break;
        case 'File bitrate is greater than 128kbps please upload different file.':
          failureMessage = 'File bitrate is greater than 128kbps please upload different file.';
          break;
        case 'diffCategory':
          failureMessage = 'This file name has already been added to your library in a different section. Please create a copy of the file with a unique file name and try again.';
          break;
        case '=> File prefix does not match':
          failureMessage = 'Filename missing Channel Prefix';
          break;
        case 'dependent':
          failureMessage = 'Media is not dependent on file prefix';
          break;
      }
      return failureMessage;
    },
    getUploadedFileProgressBarColor (file) {
      let progressBarColor = 'green';
      if (file.progress === 100) {
        if (!file.message) {
          progressBarColor = 'green progress-striped active';
        } else {
          if (file.message === 'uploaded' || file.message === 'replaced') {
            progressBarColor = 'blue';
          } else {
            progressBarColor = 'red';
          }
        }
      }
      return progressBarColor;
    },
    getUploadedFileProgressBarMessage (file) {
      let message = file.progress + '%';
      if (file.progress === 100) {
        if (!file.message) {
          message = 'Processing';
        } else {
          if (file.message === 'uploaded' || file.message === 'replaced') {
            message = 'Completed';
          } else {
            message = 'Failed';
          }
        }
      }
      return message;
    },
    confirmRemove (libraryItem) {
      this.showDeleteDialog = true;
      this.libraryItemDelete = libraryItem;
    },
    confirmRemoveMultipl (libraryItem) {
      this.showDeleteDialogMultiple = true;
    },
    confirmRemoveMultiplF (libraryItem) {
      this.showDeleteDialogMultipleF = true;
    },
    confirmRemoveMultiplM (libraryItem) {
      this.showDeleteDialogMultipleM = true;
    },
    confirmRemoveMultiplN (libraryItem) {
      this.showDeleteDialogMultipleN = true;
    },
    confirmRemoveMultiplS (libraryItem) {
      this.showDeleteDialogMultilesafety = true;
    },
    deleteMedia (libraryItem) {
      this.removeFromLibrary({
        'clientId': this.currentClient.id,
        'libraryItemId': libraryItem.id
      }).then(() => {
        this.loadLibrary(this.currentClient.id).then(() => {
          this.forceOpen(libraryItem.category.toLowerCase(), libraryItem.friendly_name);
        });
      });
      this.showDeleteDialog = false;
      this.libraryItemDelete = '';
    },
    deleteMediaMultiple (libraryItem) {
      this.showLoader = true;
      libraryItem = this.arrayLibraryDetails;
      this.removeFromLibraryMultiple({
        'clientId': this.currentClient.id,
        'libraryItemId': libraryItem
      }).then(() => {
        this.loadLibrary(this.currentClient.id).then(() => {
          this.showDeleteDialogMultiple = false;
          this.showLoader = false;
          this.shoMultiple = false;
          this.storiesExpand = false;
          this.arrayLibraryDetails = [];
          this.forceOpen(libraryItem.category.toLowerCase(), libraryItem.friendly_name);
        });
      });
    },
    deleteMediaMultiplefiller (libraryItem) {
      this.showLoader = true;
      libraryItem = this.arrayLibraryDetailsFiller;
      this.removeFromLibraryMultiple({
        'clientId': this.currentClient.id,
        'libraryItemId': libraryItem
      }).then(() => {
        this.loadLibrary(this.currentClient.id).then(() => {
          this.showDeleteDialogMultipleF = false;
          this.showLoader = false;
          this.shoMultiplefiller = false;
          this.fillersExpand = false;
          this.arrayLibraryDetailsFiller = [];
          this.forceOpen(libraryItem.category.toLowerCase(), libraryItem.friendly_name);
        });
      });
    },
    deleteMediaMultiplemusic (libraryItem) {
      this.showLoader = true;
      libraryItem = this.arrayLibraryDetailsMusic;
      this.removeFromLibraryMultiple({
        'clientId': this.currentClient.id,
        'libraryItemId': libraryItem
      }).then(() => {
        this.loadLibrary(this.currentClient.id).then(() => {
          this.showDeleteDialogMultipleM = false;
          this.showLoader = false;
          this.shoMultiplemusic = false;
          this.musicExpand = false;
          this.arrayLibraryDetailsMusic = [];
          this.forceOpen(libraryItem.category.toLowerCase(), libraryItem.friendly_name);
        });
      });
    },
    deleteMediaMultiplenotification (libraryItem) {
      this.showLoader = true;
      libraryItem = this.arrayLibraryDetailNotification;
      this.removeFromLibraryMultiple({
        'clientId': this.currentClient.id,
        'libraryItemId': libraryItem
      }).then(() => {
        this.loadLibrary(this.currentClient.id).then(() => {
          this.showDeleteDialogMultipleN = false;
          this.showLoader = false;
          this.shoMultiplenotification = false;
          this.notificationsExpand = false;
          this.arrayLibraryDetailNotification = [];
          this.forceOpen(libraryItem.category.toLowerCase(), libraryItem.friendly_name);
        });
      });
    },
    deleteMediaMultiplesafety (libraryItem) {
      this.showLoader = true;
      libraryItem = this.arrayLibraryDetailsafety;
      this.removeFromLibraryMultiple({
        'clientId': this.currentClient.id,
        'libraryItemId': libraryItem
      }).then(() => {
        this.loadLibrary(this.currentClient.id).then(() => {
          this.showDeleteDialogMultilesafety = false;
          this.showLoader = false;
          this.shoMultiplesafety = false;
          this.safetyExpand = false;
          this.arrayLibraryDetailsafety = [];
          this.forceOpen(libraryItem.category.toLowerCase(), libraryItem.friendly_name);
        });
      });
    },
    validateLibrary () {
      this.showValidateDialog = true;
      this.loadLibraryAndValidate(this.currentClient.id);
    },
    closeDialog () {
      this.showDialog = false;
    },
    closeValidateDialog () {
      this.showValidateDialog = false;
    },
    friendlyNameHasErrors (item) {
      for (let i = 0; i < item.media.length; i++) {
        if (item.media[i].uploaded === false) {
          return true;
        }
      }
      return false;
    },
    categoryHasErrors (category) {
      for (let key in category) {
        if (category.hasOwnProperty(key)) {
          if (this.friendlyNameHasErrors(category[key]) === true) {
            return true;
          }
        }
      }
      return false;
    },
    imageExists (url, callback) {
      var img = new Image();
      img.onload = function () {
        return true;
      };
      img.onerror = function () {
        return false;
      };
      img.src = url;
    },
    playMedia (el, type) {
      getSignedUrlForLibraryItem(this.currentClient.id, el.id).then(response => {
        this.playVideMp3(response.data.signedUrl, type);
      }).catch(function (error) {
        console.log('erros : ', error);
      });
    },
    playVideMp3 (signedUrl, type) {
      if (!signedUrl) {
        return;
      }
      if (type === 1) {
        this.$modal.show('video-file-play');
        this.vedioSrc = signedUrl;
        let vid = document.getElementById('video-container');
        vid.play();
      } else {
        this.$modal.show('audio-file-play');
        this.file1 = signedUrl;
      }
    },
    playSound (sound) {
      if (sound) {
        var audio = new Audio(sound);
        audio.play();
      }
    }
  },
  async mounted () {
    this.library = this.loadLibrary(this.currentClient.id);
  }
};
</script>

<style scoped type="text/css">
div.library-wrap .wrap-inner-line .inner-line {
    line-height: 32px !important;
    padding-top: 10px;
}

.activeTest {
    display: none;
}

.md-button:not([disabled])
.md-focused:before,
.md-button:not([disabled]):active:before,
.md-button:not([disabled]):hover:before {
    background-color: white !important;
    opacity: 0 !important;
}

.md-icon-button .md-ripple {
    border-radius: 0px !important;
    padding: 0px !important;
}

.library-wrap .inner-line:hover {
    background-color: #EEEEEE;
}

.library-wrap .search .search-glass-icon {
    position: absolute !important;
}

.library-wrap .search .md-icon {
    height: 36px !important;
    font-size: 24px !important;
}

.library-wrap .search {
    margin-top: 8px !important;

}

.uplado_medaia_acroller {
    width: 60%;
    overflow-y: auto;
}

.uplado_medaia_acroller .modal-body {
    max-height: 370px;
    overflow: hidden;
    overflow-y: scroll;
}


.library-wrap .search .md-button.md-icon-button {
    left: 0px !important;
    top: 0px !important;
}

.library-wrap .search input {
    width: 360px;
    font-size: 100%;
}

.file-input {
    position: absolute;
    height: 200px;
    width: 100px;
    left: -12px;
    top: 0%;
    opacity: 0;
}

.library-wrap .toolbar .right-item {
    height: 48px;
    padding-top: 10px;
}

.library-wrap .toolbar .right-item .upload-text {
    margin: 0px;
    padding: 0px;
    width: auto;
}

.upload-text {
    height: 75px;
    margin-left: 100px;
    width: 344px;
    display: inline-block;
}

.loading-icon {
    display: inline-block;
    width: 35px;
}

.fill-modal {
    width: 544px;
}

.tour-buttons .upload-btn {
    background-color: rgb(0, 168, 202) !important;
    color: rgba(255, 255, 255, 0.87) !important;
}

.vueAudioCass {
    margin-left: 10pc;
    margin-top: 20%;
}

.logout-button .md-button {
    color: white;
    background-color: #00A8CA;
    margin: 0;
}

.logout-button .md-button {
    color: white;
    background-color: #00A8CA;
    margin: 0;
}

.ManualBtn {
    display: inline-block !important;
    margin-bottom: 0 !important;
    font-weight: 400 !important;
    text-align: center !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    -ms-touch-action: manipulation !important;
    touch-action: manipulation !important;
    background-image: none !important;
    border: 1px solid transparent !important;
    padding: 6px 12px !important;
    font-size: 14px !important;
    line-height: 1.42857143 !important;
    border-radius: 4px !important;
    color: #fff !important;
}

.ManualBtndelete {
    background-color: #d9534f !important;
}

.ManualBtncancel {
    color: white !important;
    background-color: #00a8ca !important;
    border-color: #ccc !important;
    margin: 0 8px;
    float: left;
    width: 19%;
    padding: 8px !important;
}

ManualBtncancelMultiple {
    color: white !important;
    background-color: #00a8ca !important;
    border-color: #ccc !important;
    margin: 0 8px;
    float: left;
    width: 19%;
    padding: 8px !important;
    color: white !important;
    background-color: #00a8ca !important;
    border-color: #ccc !important;
}

.modal-body .full-btn {
    position: absolute;
    bottom: 1px;
    width: 100%;
}

.full-btn {
    padding-right: 20px !important;
    padding-left: 10px !important;
}

.cssForAddLibrray {
    padding: 11px;
}

.imgAudioVideo {
    width: 32px;
}

.export-button {
    margin: 14px 0 14px 8px;
    color: rgba(255, 255, 255, 0.87);
    background-color: rgb(0, 168, 202);
}

.a11 {
    left: -20px !important;
    width: 100% !important;
}

.export-button .addFileToanotherRoute {
    margin: 14px 0 14px 8px;
    color: rgba(255, 255, 255, 0.87);
    background-color: rgb(0, 168, 202);
}

@keyframes animate-stripes {
    0% {
        background-position: 0 0;
    }

    100% {
        background-position: 60px 0;
    }
}

@keyframes auto-progress {
    0% {
        width: 0%;
    }

    100% {
        width: 100%;
    }
}

.progress-bar {
    background-color: #1a1a1a;
    height: 20px;
    width: 300px;
    margin-bottom: 50px auto;
    border-radius: 0px;
    box-shadow: 0 1px 5px #000 inset, 0 1px 0 #444;
}

.stripes {
    background-size: 30px 30px;
    background-image: linear-gradient(
        135deg,
        rgba(255, 255, 255, .15) 25%,
        transparent 25%,
        transparent 50%,
        rgba(255, 255, 255, .15) 50%,
        rgba(255, 255, 255, .15) 75%,
        transparent 75%,
        transparent
    );
}

.stripes.animated {
    animation: animate-stripes 0.6s linear infinite;
}

.stripes.animated.slower {
    animation-duration: 1.25s;
}

.stripes.reverse {
    animation-direction: reverse;
}

.progress-bar-inner {
    display: block;
    height: 30px;
    width: 0%;
    background-color: #34c2e3;
    border-radius: 30px;
    box-shadow: 0 1px 0 rgba(255, 255, 255, .5) inset;
    position: relative;
    animation: auto-progress 20s infinite linear;
}


.export-button:hover {
    margin: 14px 0 14px 8px;
    color: rgba(255, 255, 255, 0.87);
    background-color: rgb(0, 168, 202);
}

.export-button .md-ripple .md-button-content {
    margin-right: 11px;
}

.full-size-video video {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
}

button.md-button.ManualBtn.ManualBtndelete.md-theme-default span.md-button-content {
    font-size: 15px;
}

button.md-button.ManualBtn.ManualBtncancel.md-theme-default span.md-button-content {
    font-size: 15px;
}

.right-item {
    width: 50%;
    padding-left: 5%;
    justify-content: flex-end;
    display: flex;
    white-space: normal;
}

.left-item1 {
    width: 50%;
    padding-right: 5%;
    justify-content: flex-start;
    display: flex;
    white-space: normal;
}

.fillupload-table {
    width: 100%;
    margin: 20px;
    padding: 0 30px;
}

.fillupload-table thead tr th {
    text-align: left;
}

.up-filename {

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 270px;

}

.fillupload-table .md-theme-default.green {
    color: #4caf50;
    background: none;
}

.fillupload-table .md-theme-default.red {
    color: red;
    background: none;
}

.fillupload-table.md-theme-default.red {
    color: #fd0c0a;
}

.fillupload-table .e-message {
    color: #fd0c0a;
}

.fillupload-table tr td {
    padding: 10px 0;
}

.progress {
    background-color: #f5f5f5;
    border-radius: 3px;
    box-shadow: none;
}

.progress-bar {
    box-shadow: none;
}

.progress-bar.text-left {
    text-align: left;
}

.progress-bar.text-left span {
    margin-left: 10px;
}

.progress-bar.text-right {
    text-align: right;
}

.progress-bar.text-right span {
    margin-right: 10px;
}

@-webkit-keyframes progress-bar-stripes {
    from {
        background-position: 40px 0;
    }
    to {
        background-position: 0 0;
    }
}

@keyframes progress-bar-stripes {
    from {
        background-position: 40px 0;
    }
    to {
        background-position: 0 0;
    }
}

.progress.active .progress-bar,
.progress-bar.active {
    -webkit-animation: progress-bar-stripes 2s linear infinite;
    -o-animation: progress-bar-stripes 2s linear infinite;
    animation: progress-bar-stripes 2s linear infinite;
}

.progress-striped .progress-bar,
.progress-bar-striped {
    background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    background-size: 40px 40px;
}

.progress {
    min-width: 300px;
    margin-right: 20px;
}

.progress-bar {
    text-align: center;
    color: #ffffff;
}

.progress-bar.green {
    background-color: #1eac35;
}

.progress-bar.red {
    background-color: #f50000;
}

.progress-bar.blue {
    background-color: #34c2e3;
}
</style>



// WEBPACK FOOTER //
// src/components/client/LibraryTab.vue